// import { TweenLite } from 'gsap'

import carousel from '@/js/util/symbols/carousel'
import BaseWindowWidth from '@/js/components/BaseWindowWidth'

export default {
  inject: { carousel },
  extends: BaseWindowWidth,
  props: {},

  data() {
    return {
      defaultClass: undefined,
    }
  },

  mounted() {
    this.defaultClass = [...this.$el.classList]
  },

  created() {
    this.emitEvent('create:items', this)
  },

  computed: {
    evaluateItem() {
      return this.carousel.currentItem === this
    },
  },

  methods: {
    emitEvent(...events) {
      this.carousel.$emit(...events)
    },

    handleEvent() {
      this.emitEvent('set:item', this)
    },

    handleFocus(e) {
      e.preventDefault()
      this.$el.click()
    },
  },

  render(createElement) {
    const ariaInfo = {
      'aria-hidden': !this.evaluateItem,
    }
    const elementData = {
      attrs: ariaInfo,
      on: {
        click: this.handleEvent,
        focus: this.handleFocus,
        focusin: this.handleFocus,
      },
      class: {
        [`${this.defaultClass}--isActive`]: this.evaluateItem,
      },
    }

    const createsChild = createElement(
      'div',
      { staticClass: 'CarouselContainerListItem' },
      this.$slots.default
    )

    return createElement('li', elementData, [createsChild])
  },
}
